import { Col, Modal, Row } from "antd";
import DefaultButton from "ui/components/Button/PrimaryButton";
import { Flex, Box, Text, Checkbox, Textarea } from "@chakra-ui/react";
import { Button } from "@chakra-ui/button";
import RangeDates from "../RangeDates";
import Field from "ui/components/Input/Field";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { AreaComumBloqueioDataItem } from "core/features/area-comum/typings";

export interface ModalBloqueioDataProps {
  open: boolean;
  defaultData?: AreaComumBloqueioDataItem;
  onSaved: (values: AreaComumBloqueioDataItem) => void;
  onClose: () => void;
}

function ModalBloqueioData({
  open,
  onSaved,
  defaultData,
  onClose,
}: ModalBloqueioDataProps) {
  const [bloquearPeriodo, setBloquearPeriodo] = useState<boolean>(
    !!defaultData?.dataFim
  );
  const { control, handleSubmit, watch, reset, setValue } =
    useForm<AreaComumBloqueioDataItem>({
      defaultValues: {
        items: [],
      },
    });

  useEffect(() => {
    if (defaultData) {
      reset(defaultData);
    }
  }, [defaultData, reset]);

  return (
    <Modal
      visible={open}
      title={"Bloqueio de datas"}
      onCancel={onClose}
      width={"960px"}
      footer={
        <Flex pt="16px" gridGap="16px" justifyContent="flex-end">
          <Button onClick={() => onClose()} fontSize={14}>
            CANCELAR
          </Button>

          <DefaultButton type="submit" form="cadastrar-bloqueio-area-comum">
            INCLUIR BLOQUEIO
          </DefaultButton>
        </Flex>
      }
    >
      <form
        onSubmit={handleSubmit((v) => {
          if (!defaultData) {
            v.id = +new Date();
          }

          onSaved(v);
        })}
        id="cadastrar-bloqueio-area-comum"
      >
        <Box>
          <Row gutter={32}>
            <Col sm={8}>
              <Field
                control={control}
                label="Data"
                name="dataInicio"
                rules={{ required: "Campo obrigatório" }}
                inputProps={{
                  type: "date",
                }}
              />
            </Col>

            {bloquearPeriodo ? (
              <Col sm={8}>
                <Field
                  control={control}
                  label="Final do bloqueio"
                  name="dataFim"
                  rules={{ required: "Campo obrigatório" }}
                  inputProps={{
                    type: "date",
                  }}
                />
              </Col>
            ) : null}
            <Col sm={8}>
              <Field
                label="Motivo"
                control={control}
                name="motivo"
                render={({ field, isInvalid }) => (
                  <Textarea
                    isInvalid={isInvalid}
                    className="chakra-input"
                    rows={3}
                    placeholder="Digite..."
                    {...field}
                  />
                )}
              />
            </Col>

            <Col sm={8}>
              <Checkbox
                mt="28px"
                onChange={() => {
                  setBloquearPeriodo(!bloquearPeriodo);

                  setValue("dataFim", undefined);
                }}
                isChecked={bloquearPeriodo}
              >
                Bloquear período
              </Checkbox>
            </Col>
          </Row>

          {watch("dataFim") ? (
            <>
              <Text mt="48px" mb="32px" fontSize="18px">
                Dias da semana que serão bloqueados
              </Text>
              <Flex mb="16px" w="100%" gap="8px">
                <Field
                  name="items"
                  control={control}
                  render={({ field }) => <RangeDates {...field} />}
                />
              </Flex>
            </>
          ) : null}
        </Box>
      </form>
    </Modal>
  );
}

export default ModalBloqueioData;
